import { pixelToDxa } from '@/libs/utils/docxUtils'
import {
  AlignmentType,
  PageBreak,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign,
  WidthType,
  HeadingLevel,
  TableLayoutType,
} from 'docx'
import SectionHeader from '../../SectionHeader'
import { tableWidthDxa1150 } from '../../constants'

const getCellProps = ({ color, value, children }) => ({
  margins: { top: 100, bottom: 100, left: 100, right: 100 },
  verticalAlign: VerticalAlign.CENTER,
  shading: { fill: color },
  children: children || [new Paragraph({ children: value, alignment: AlignmentType.CENTER })],
})
const Row = ({ first = [], second = [], third = [], forth = [], color = 'FFFFFF' }) =>
  new TableRow({
    height: { value: pixelToDxa(40) }, // 設置行高
    children: [
      new TableCell({
        ...getCellProps({ color, value: first }), // 第一欄
      }),
      new TableCell({
        ...getCellProps({ color, value: second }), // 第二欄
      }),
      new TableCell({
        ...getCellProps({ color, value: third }), // 第三欄
      }),
      new TableCell({
        ...getCellProps({ color, value: forth }), // 第四欄
      }),
    ],
  })

const Chapter3Sub2Page = ({ reportData }) => {
  const { emailTempLogReports, phishType, secondaryCompanyNickname } = reportData || {}
  const service = phishType

  return [
    new Paragraph({ children: [new PageBreak()] }),
    new Paragraph(''),
    SectionHeader({
      text: '3.5 執行內容',
      size: 48,
      headingNumber: HeadingLevel.HEADING_2,
    }),
    new Paragraph(''),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '依社交工程測試專案要求，郵件內容設計可涵蓋不同類型，以供受測單位進行測試，且每封範本經雙方協議之模式加以評定範本之有效性與強度。測試信件將夾帶特製之識別因子，於瀏覽信件、點閱連結及下載附件時，會啟動回報機制，',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: secondaryCompanyNickname,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '僅進行資料統計，於測試期間並無任何入侵行為。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: secondaryCompanyNickname,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '將於測試前與承辦單位充分溝通及確認測試細節，於約定之測試時程，',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: secondaryCompanyNickname,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '將採用無預警方式寄發測試郵件進行演練，以防受測單位採取預警措施，將影響統計結果。此外寄發測試郵件時間應選擇組織成員一般工作時間，避免如員工旅遊、單位受訓等情況下進行測試，以求測試統計結果的完整性與客觀程度。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: secondaryCompanyNickname,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '將提供不同行為模式之分析報告，報告之格式可依單位之需要，經協議後進行客製化作業。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),
    SectionHeader({
      text: '3.6 檢測信件範本',
      size: 48,
      headingNumber: HeadingLevel.HEADING_2,
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '依社交工程測試專案要求，',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: service,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '內容設計可涵蓋不同類型，以供受測單位進行測試。本次檢測範本如下列所示：',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),
    new Table({
      indent: { size: pixelToDxa(-50), type: WidthType.DXA },
      layout: TableLayoutType.FIXED,
      columnWidths: [
        (tableWidthDxa1150 - pixelToDxa(100)) / 5,
        (tableWidthDxa1150 - pixelToDxa(100)) / 2,
        (tableWidthDxa1150 - pixelToDxa(100)) / 4,
        (tableWidthDxa1150 - pixelToDxa(100)) / 2,
      ],
      width: { size: tableWidthDxa1150, type: WidthType.DXA },
      rows: [
        Row({
          first: [
            new TextRun({
              text: '樣板編號',
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 20,
            }),
          ],
          second: [
            new TextRun({
              text: '信件標題',
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 20,
            }),
          ],
          third: [
            new TextRun({
              text: '寄件者',
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 20,
            }),
          ],
          forth: [
            new TextRun({
              text: '寄件者信箱',
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 20,
            }),
          ],
        }),
        ...(Array.isArray(emailTempLogReports) && emailTempLogReports.length > 0
          ? emailTempLogReports.map(({ tempSubject, sendName, sendSource }, index) =>
              Row({
                first: [
                  new TextRun({
                    text: `${index + 1}`,

                    bold: true,
                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
                second: [
                  new TextRun({
                    text: tempSubject || '無資訊',

                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
                third: [
                  new TextRun({
                    text: sendName || '無資訊',

                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
                forth: [
                  new TextRun({
                    text: sendSource || '無資訊',

                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
              }),
            )
          : []),
      ],
    }),
  ]
}

export default Chapter3Sub2Page
